
"use client";

import React, { useState, useEffect } from "react";
import Link from "next/link";
import { navLinks } from "@/db/navLinks";
import { usePathname } from "next/navigation";
import { Search, Facebook, Instagram } from "lucide-react";
import { AiOutlineUser } from "react-icons/ai";
import { API_BASE_URL, PRIVATE_WEBSITE_URL, PRIVATE_PARENT_WEBSITE_URL } from "@/constants/env";
import { useCxcRegistrationStatus } from "@/constants/cxcRegistrationConfig";

const Header: React.FC = () => {
  const pathname = usePathname();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const [isSticky, setIsSticky] = useState(false);
  // Open/closed as the server sees it (GET /CxcSettings/options) - never a date compiled into the site.
  const isCxcOpen = useCxcRegistrationStatus()?.isOpen ?? false;


  const toggleDropdown = (menu: string) => {
    setOpenDropdown(openDropdown === menu ? null : menu);
  };
  const toggleMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={`navbar-area `} style={{ overflowX: "clip" }}>

      {/* Mobile Nav */}
      <div className={`mean-container md-none ${isSticky ? "is-sticky" : ""}`}>
        <div className="mobile-nav">
          <Link href="/" className="logo">
            <img
              src="/images/cayman_acadmy_logo.png"
              className="main-logo h-10 w-auto"
              alt="logo"
            />
          </Link>

          <button
            type="button"
            className={`meanmenu-reveal ${isMobileMenuOpen ? "meanclose" : ""}`}
            style={{
              right: "0px",
              left: "auto",
              textAlign: "center",
              textIndent: "0px",
              fontSize: "18px",
              background: "none",
              border: "none",
              padding: 0,
              cursor: "pointer",
            }}
            onClick={toggleMenu}
            aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
          >
            <div className="custom-menu-icon">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <nav className="mobile-menu mean-nav bg-white shadow-md">
            <ul className="navbar-nav text-right">

              {navLinks.map((link, index) => {
                const hasSubmenu = link.submenu && link.submenu.length > 0;
                const isOpen = openDropdown === link.title;

                return (
                  <li key={index} className="nav-item">
                    {hasSubmenu ? (
                      <>
                        <a
                          href="#"
                          className="nav-link"
                          onClick={(e) => {
                            e.preventDefault();
                            toggleDropdown(link.title);
                          }}
                        >
                          {link.title}
                          <span className="mean-expand">
                            {isOpen ? "-" : "+"}
                          </span>
                        </a>

                        {isOpen && (
                          <ul className="dropdown-menuitem">
                            {link.submenu?.map((sub, subIndex) => {
                              const isCxc = sub.href === "/cxc-registration";
                              return (
                                <li key={subIndex} className="nav-item">
                                  <Link
                                    href={sub.href}
                                    className="nav-link d-flex align-items-center justify-content-between"
                                    onClick={() => setIsMobileMenuOpen(false)}
                                  >
                                    <span className="d-flex align-items-center">
                                      {sub.title}
                                    </span>
                                    {isCxc && isCxcOpen && <span className="cxc-menu-badge">OPEN</span>}
                                  </Link>
                                </li>
                              );
                            })}
                          </ul>
                        )}
                      </>
                    ) : (
                      <Link href={link.href} className="nav-link" onClick={() => setIsMobileMenuOpen(false)}>
                        {link.title}
                      </Link>
                    )}
                  </li>
                );
              })}

              {/* Mobile Sign In Dropdown */}
              <li className="nav-item">
                <a
                  href="#"
                  className="nav-link"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleDropdown("Sign In");
                  }}
                >
                  <div className="signicon">
                    <AiOutlineUser size={20} />
                    Sign In
                  </div>
                  <span className="mean-expand">
                    {openDropdown === "Sign In" ? "-" : "+"}
                  </span>
                </a>

                {openDropdown === "Sign In" && (
                  <ul className="dropdown-menuitem">
                    <li className="nav-item">
                      <Link href={PRIVATE_PARENT_WEBSITE_URL} target="_blank" rel="noopener noreferrer" className="nav-link">
                        Parent
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link href={PRIVATE_WEBSITE_URL} target="_blank" rel="noopener noreferrer" className="nav-link">
                        Employee
                      </Link>
                    </li>

                    <li className="nav-item">
                      <Link href="#" className="nav-link">
                        Office 365
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link href="#" className="nav-link">
                        QuickSchool
                      </Link>
                    </li>
                  </ul>
                )}
              </li>

              {/* <li className="nav-item">
                <a href="#" className="nav-link" onClick={(e) => e.preventDefault()}>
                  <Search size={18} />
                </a>
              </li> */}


            </ul>
          </nav>
        )}

      </div>



      {/* Desktop Nav */}
      <div className={`main-nav poistion-static md-block ${isSticky ? "is-sticky" : ""}`} >

        <div className="container px-2">
          <nav className="navbar navbar-expand-md navbar-light py-0">
            <Link className="navbar-brand" href="/" style={{ minWidth: "160px" }}>
              <img
                src="/images/cayman_acadmy_logo.png"
                className="main-logo"
                alt="logo"
                style={{ height: "55px", width: "auto" }}
              />
              <img
                src="/images/cayman_acadmy_logo.png"
                className="white-logo"
                alt="logo"
                style={{ height: "55px", width: "auto" }}
              />
            </Link>

            <div
              className="collapse navbar-collapse mean-menu"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav text-right w-100 align-items-center">
                {navLinks.map((link, index) => {
                  const hasSubmenu = link.submenu && link.submenu.length > 0;
                  const isActive = pathname === link.href;
                  const isLast = index === navLinks.length - 1;

                  return (
                    <li key={index} className="nav-item">
                      {hasSubmenu ? (
                        <>
                          <Link href={link.href} className={`nav-link dropdown-toggle ${isActive ? "active" : ""}`} >
                            {link.title}
                          </Link>
                          <ul className="dropdown-menu" style={isLast ? { left: "auto", right: 0 } : {}}>
                            {link.submenu?.map((sub, subIndex) => {
                              const isCxc = sub.href === "/cxc-registration";
                              return (
                                <li key={subIndex} className="nav-item">
                                  <Link href={sub.href} className="nav-link d-flex align-items-center justify-content-between">
                                    <span className="d-flex align-items-center">
                                      {sub.title}
                                    </span>
                                    {isCxc && isCxcOpen && <span className="cxc-menu-badge">OPEN</span>}
                                  </Link>
                                </li>
                              );
                            })}
                          </ul>
                        </>
                      ) : (
                        <Link href={link.href} className={`nav-link ${isActive ? "active" : ""}`} >
                          {link.title}
                        </Link>
                      )}
                    </li>
                  );
                })}

              </ul>
            </div>

            {/* Desktop Sign In Dropdown */}
            <ul className="navbar-nav align-items-center">
              <li className="nav-item">
                <a href="#" className="nav-link dropdown-toggle removeicon" >
                  <div className="signicon">
                    <AiOutlineUser size={20} />
                    Sign In
                  </div>
                </a>
                  <ul className="dropdown-menu">
                    <li className="nav-item">
                      <a href={PRIVATE_PARENT_WEBSITE_URL} className="nav-link" target="_blank" rel="noopener noreferrer">
                        Parent
                      </a>
                    </li>
                    <li className="nav-item">
                      <a href={PRIVATE_WEBSITE_URL} className="nav-link" target="_blank" rel="noopener noreferrer">
                        Employee
                      </a>
                    </li>
                    <li className="nav-item">
                      <Link href="#" className="nav-link">
                        Office 365
                      </Link>
                    </li>

                    <li className="nav-item">
                      <Link href="#" className="nav-link">
                        QuickSchool
                      </Link>
                    </li>

                  </ul>
                </li>
              </ul>
          </nav>
        </div>

      </div>
    </div>
  );
};

export default Header;
